"use strict";

exports.__esModule = true;
exports.compareElementPaths = compareElementPaths;
/**
 * Compare two element paths.
 */
function compareElementPaths(a, b) {
  var limit = Math.max(a.length, b.length);
  for (var i = 0; i < limit; i++) {
    if (i >= a.length) {
      return -1;
    }
    if (i >= b.length) {
      return 1;
    }
    var aValue = a[i];
    var bValue = b[i];
    if (typeof aValue === "number" && typeof bValue === "number") {
      if (aValue > bValue) {
        return 1;
      }
      if (aValue < bValue) {
        return -1;
      }
    } else if (typeof aValue === "string" && typeof bValue === "string") {
      if (aValue > bValue) {
        return 1;
      }
      if (aValue < bValue) {
        return -1;
      }
    } else {
      if (typeof aValue === "string") {
        return 1;
      }
      return -1;
    }
  }
  return 0;
}